import React from 'react';
import styled, { css } from 'styled-components';
import { PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { BROWN_OVERLAY } from '../../theme';
import { ActiveEntityProvider, ContentEntityLayout, EntityTitleHeader, PageHeader, RelatedEntityItemsProvider, SliceEntityImagePageHeader, SliceLayoutBoundary, useActiveEntity } from '@shapeable/ui';
import { useReflections } from '../../hooks/use-reflections';

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
  `,
});

const ContentLayoutStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(8)};
    margin-top: ${theme.UNIT(8)};
  `,
  tablet: css`
    margin-top: ${theme.UNIT(10)};
  `,
  desktop: css`
    margin-top: ${theme.UNIT(12)};
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<any>`${ContainerStyles}`,
  ContentLayout: styled(ContentEntityLayout)`${ContentLayoutStyles}`,
};

export const PageLayoutDefault: PageLayoutComponent = (props) => {
  const { entity, slices, className } = props;

  const activeEntity = useActiveEntity();

  // need to work out why the Active Entity Provider is providing the SLICE below - this is wrong, the Slice should be the
  // entity provider, the active entity should always be the overridden "navigation" entity

  const reflections = useReflections();

  
  return (
    <RelatedEntityItemsProvider value={reflections}>
    <My.Container className={className}>
      <SliceLayoutBoundary verticalPadding='none'>
        <My.ContentLayout 
          showTitles={false}
          showMeta={false}
          showImage={false}
          entity={entity} />
      </SliceLayoutBoundary>
      <ActiveEntityProvider value={activeEntity}>
      {slices}
      </ActiveEntityProvider>
    </My.Container>
    </RelatedEntityItemsProvider>
  )
};
